export default {
  LOAD_STUDY_PROGRAM_CYCLE_LIST_START: 'LoadStudyProgramCycleListStart',
  LOAD_STUDY_PROGRAM_CYCLE_LIST_END: 'LoadStudyProgramCycleListEnd'
};